import Vue from "vue";
import VClamp from "vue-clamp";

Vue.use(VClamp);
